import { render, staticRenderFns } from "./GridPage.vue?vue&type=template&id=34ce31d4&scoped=true&"
import script from "./GridPage.vue?vue&type=script&lang=js&"
export * from "./GridPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ce31d4",
  null
  
)

export default component.exports